// src/components/store/sections/gallery/GalleryV70InstagramsquareIndigoPulse.tsx
"use client";

import React from "react";
import DynamicGalleryVariant from "./DynamicGalleryVariant";

export default function GalleryV70InstagramsquareIndigoPulse(props: any) {
  return (
    <DynamicGalleryVariant
      variantNumber={70}
      archKey="instagram_square"
      archLabel="Instagram Square Grid"
      palName="IndigoPulse"
      grad="from-indigo-500 via-blue-600 to-violet-700"
      lightBg="bg-indigo-50"
      textCol="text-indigo-700"
      borderCol="border-indigo-200"
      btnCls="bg-indigo-600 hover:bg-indigo-700"
      hexCol="#6366f1"
      {...props}
    />
  );
}
